import { useState, useEffect } from "react";
import { PropostaService } from "../../services/fornecedor/proposta.service";
import { columnDescriptions } from "./columnDescriptions";
import { ListaProposta } from "./lista/ListaProposta";
import { Alert } from "../shared/alert/Alert";
import { useAuth } from "../../contexts/AuthContext";

export const Proposta = () => {
  const { user } = useAuth();
  const storageKey = "proposalTableFilters";
  const now = new Date();
  const defaultDate = now.toISOString().split("T")[0];

  if (!localStorage.getItem(`${storageKey}_dataInicio`)) {
    localStorage.setItem(`${storageKey}_dataInicio`, defaultDate);
  }

  if (!localStorage.getItem(`${storageKey}_dataFim`)) {
    localStorage.setItem(`${storageKey}_dataFim`, defaultDate);
  }

  const [dataInicio, setDataInicio] = useState(localStorage.getItem(`${storageKey}_dataInicio`));
  const [dataFim, setDataFim] = useState(localStorage.getItem(`${storageKey}_dataFim`));
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [columnFilters, setColumnFilters] = useState([]);

  useEffect(() => {
    localStorage.removeItem(storageKey);
    setColumnFilters([]);
  }, []);

  useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify(columnFilters));
  }, [columnFilters]);

  const handleFiltering = (filtros = []) => {
    setPage(1);
    setColumnFilters(filtros);
  };

  const fetchData = async (pageNumber = 1, pageSize = limit, inicio = dataInicio, fim = dataFim, filtros = columnFilters) => {
    if (!user?.token) return;

    setLoading(true);
    try {
      if (filtros.length > 0) {
        const payload = {
          filtros: filtros.map(f => ({
            campo: f.campo || f.id,
            valor: f.valor || f.value,
            uselike: f.uselike ?? true,
          })),
        };

        const response = await PropostaService.filtrarPropostas(user.token, payload, true, pageNumber, pageSize);
        const { docs = [], total: totalRecords = 0 } = response || {};
        setData(docs);
        setTotal(totalRecords);

        if (docs.length && columns.length === 0) {
          setColumns(Object.keys(docs[0]).map(key => ({
            accessorKey: key,
            header: columnDescriptions[key],
          })));
        }
      } else {
        let response;
        if (user.tipusu === "FORNECEDOR") {
          response = await PropostaService.getPropostasAgrupadoByCodCli(user.token, user.codope, inicio, fim, true, pageNumber, pageSize);
        } else {
          response = await PropostaService.getPropostasAgrupado(user.token, inicio, fim, true, pageNumber, pageSize);
        }

        const { docs = [], total: totalRecords = 0 } = response || {};
        setData(docs);
        setTotal(totalRecords);

        if (docs.length && columns.length === 0) {
          setColumns(Object.keys(docs[0]).map(key => ({
            accessorKey: key,
            header: columnDescriptions[key],
          })));
        }
      }
    } catch (error) {
      const message = error.response?.data?.erro || error.message;
      Alert({
        title: "Erro",
        message: `Não foi possível listar as propostas: ${message}`,
        icon: "error",
        showConfirmButton: true,
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleFiltroData = () => {
    localStorage.setItem(`${storageKey}_dataInicio`, dataInicio);
    localStorage.setItem(`${storageKey}_dataFim`, dataFim);
    setPage(1);
    fetchData(1, limit, dataInicio, dataFim, columnFilters);
  };

  useEffect(() => {
    if (!user?.token) return;
    fetchData(page, limit, dataInicio, dataFim, columnFilters);
  }, [page, limit, columnFilters, user?.token]);

  return (
    <ListaProposta
      columns={columns}
      data={data}
      setData={setData}
      page={page}
      setPage={setPage}
      limit={limit}
      setLimit={setLimit}
      total={total}
      setTotal={setTotal}
      loading={loading}
      handleFiltering={handleFiltering}
      handleFiltroData={handleFiltroData}
      storageKey={storageKey}
      setLoading={setLoading}
      dataInicio={dataInicio}
      setDataInicio={setDataInicio}
      dataFim={dataFim}
      setDataFim={setDataFim}
      getRowStyle={(row) => {
        if (row.status === "APROVADA") return { backgroundColor: "#DFF5E1" };
        if (row.status === "REPROVADA") return { backgroundColor: "#f5dfdfff" };
        if (row.status_res === "PENDENTE") return { backgroundColor: "#FFF8DC" };
        if (row.status_res === "RESPONDIDO") return { backgroundColor: "#d9f2ffff" };
        return {};
      }}
      legend={[
        { color: "#DFF5E1", label: "Aprovada" },
        { color: "#f5dfdfff", label: "Reprovada" },
        { color: "#FFF8DC", label: "Pendente" },
        { color: "#d9f2ffff", label: "Respondido" }
      ]}
    />
  );
};
